import React, { useEffect, useState, useRef, memo } from 'react';
import { InView } from 'react-intersection-observer';

const RightSideBar = ({ className, children }) => {
  const [eleHeight, setEleHeight] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const rightSidebarRef = useRef(null);

  useEffect(() => {
    if (document.getElementById('headerDesktopNavBar')) {
      setEleHeight(document.getElementById('headerDesktopNavBar').offsetHeight);
    }
    // updatePosition();
  }, []);

  useEffect(() => {
    function updatePosition() {
      if (!isSticky) {
        setScrollHeight({ scrollX: window.scrollX, scrollY: window.scrollY });
      }
    }
    window.addEventListener('scroll', updatePosition);
    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);
  }, [isSticky]);

  return (
    <div
      className={`col-lg-3 pe-4 ps-0 d-lg-flex flex-column gap-4 d-none z-0 clr_v3_rightSideBar position-sticky ${
        className ? className : ''
      } 
      
      `}
      // ${isSticky ? 'position-sticky' : ''}
      style={{ top: `${eleHeight + 15 - scrollHeight.scrollY}px` }}
      ref={rightSidebarRef}
    >
      <div className="w-100 d-flex flex-column gap-lg-4 gap-3">{children}</div>
      <InView as="div" onChange={(inView, entry) => setIsSticky(inView)}>
        <div></div>
      </InView>
    </div>
  );
};

export default memo(RightSideBar);
